import { useCompetitionRegistrationCategorySummaryQuery } from '~/pages/competition/set-category/queries';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { useParams } from '~/hooks/useParams';
import { HasStyle } from '~/types/HasStyle';
import { idParamSchema } from '~/schemas';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & HasStyle;

function RegisterLifterAgeCategorySelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { id } = useParams(idParamSchema.parse);

  const { data: competitionCategories } = useCompetitionRegistrationCategorySummaryQuery(id);

  const options = Array.from(
    competitionCategories
      ?.reduce((map, c) => {
        c.age_categories.forEach(ageCategory => {
          const { label, id } = ageCategory.age_category;
          if (!map.has(id)) {
            map.set(id, [label, id] as [string, number]);
          }
        });
        return map;
      }, new Map<number, [string, number]>())
      .values() ?? []
  );

  return (
    <Input.Select
      disabled={!options}
      placeholder="Välj ålderskategori"
      name="age_category"
      options={options ?? []}
      ref={ref}
      {...props}
    />
  );
}

export const RegisterLifterAgeCategorySelect = forwardRef(RegisterLifterAgeCategorySelectElement) as <
  TFormState extends BaseFormState,
>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof RegisterLifterAgeCategorySelectElement>;
